import { Data } from "@8x8/chalet-proto";
import I from "immutable";

export { Data } from "@8x8/chalet-proto";

export const defaultAuthorUser: Data.AuthorUser = {
    id: "",
    name: "",
    email: "",
    avatar_url: "",
    is_bot: false,
};

export type PageTextExtended = Data.PageText & {
    __meta__?: {
        hasFailed: boolean;
        pendingRaw?: string;
    };
};

export const defaultPageText: Data.PageText = {
    id: "",
    ts: 0,
    raw: undefined,
    parsed: "",
    author_user: defaultAuthorUser,
    unseen: false,
    meta: undefined,
    quoted: undefined,

    mentioned_user_ids: [],
    mentions: [],

    shared_files: [],
    deleted: undefined,
    version: undefined,
    last_update_ts: undefined,
    reactions: undefined,
};

export const defaultPageTextExtended: PageTextExtended = {
    ...defaultPageText,
    __meta__: undefined,
};

export interface PageTextRecord extends I.Record<Data.PageText>, Data.PageText {}
export interface PageTextExtendedRecord extends I.Record<PageTextExtended>, PageTextExtended {}

export const PageTextRecordFactory = I.Record(defaultPageText);
export const PageTextExtendedRecordFactory = I.Record(defaultPageTextExtended);

export const defaultSearchText: Data.SearchText = {
    ...defaultPageText,
    room_id: undefined,
};

export interface SearchTextRecord extends I.Record<Data.SearchText>, Data.SearchText {}
export interface GlobalSearchTextRecord extends SearchTextRecord {
    room_id: string; // global search results have room_id
}

export const SearchTextRecordFactory = I.Record(defaultSearchText);

type PageTextWithMeta = PageTextExtended & Required<Pick<PageTextExtended, "__meta__">>;

export function hasMeta(message: PageTextExtended): message is PageTextWithMeta {
    return "__meta__" in message && !!message.__meta__;
}

export interface SameroomConnection {
    id: string;
    type: string;
    name: string;
    unit_name: string; // empty string for providers without unit_name
    provider_name: string;
}

export interface SameroomRoomMeta {
    connections: SameroomConnection[];
}

export interface RoomMeta {
    sameroom?: SameroomRoomMeta;
    private_hide_sameroom_warning?: true;
}

export type CollapsedCTIState = "online" | "offline" | "busy" | "dnd-on";

export type RoomGroup = "all" | "forums" | "dialogs" | "external";

export interface ProfileData {
    all_notifications_disabled_until_ts?: number;
    follow_notifications_disabled_until_ts?: number;
}

export type MuteType = "everything" | "non_mentions";
export type MutePeriod = "for_1_hour" | "until_8_am" | "forever";
